/*  ==========================================================================
    ACCORDIONS
    Helper to make a element openable on click.

    INFO:
    - you can add also your own accordions if existing ones don't work for
      your requirements!
    - each accordion must have following css classes and should be
      structured (roughly) like this:

    <div class="bn-accordion">
        <div class="bn-accordion__trigger">
            Title
        </div>
        <div class="bn-accordion__slide">
            Content
        </div>
    </div>
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';

/*
 * SIMPLE ACCORDION
 */

// accordion without slide animation
export function initSimpleAccordion($element) {
    if ($element.hasClass('bn-accordion')) {
        $element.on('click', '.bn-accordion__trigger', function () {
            let $this = $(this);
            if ($this.hasClass('bn-accordion__trigger--act')) {

                // close this accordion if already open
                $this.parents('.bn-accordion').removeClass('bn-accordion--opened');
                $this.removeClass('bn-accordion__trigger--act');
                $this.parents('.bn-accordion').find('.bn-accordion__slide').removeClass('bn-accordion__slide--open');

            } else {

                // open this accordion
                $this.parents('.bn-accordion').addClass('bn-accordion--opened');
                $this.addClass('bn-accordion__trigger--act');
                $this.parents('.bn-accordion').find('.bn-accordion__slide').addClass('bn-accordion__slide--open');

                if ($element.find('.JS-frame').length) {
                    $element.find('.JS-frame').each(function () {
                        if (!$(this).hasClass('JS-frame--loaded')) {
                            const segment = $(this).attr('data-sm-segment');
                            $element.find('iframe').attr('src', 'https://map.schweizmobil.ch/?embed&lang=' + vars.lang + '&land=veloland&etappe=' + segment + '&onlyRoute=&');
                            $(this).addClass('JS-frame--loaded');
                        }
                    });
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./source/js/utilities/lib/accordions.js